// index
import {isLoginMode} from "src/config/Config";

export const PROGRAM_HEADER_TO_INDEX_MAP_NA = {
    // We updated the template in NA for new IPS fee.
    amazonStore: 0,
    program1: 1,
    ipsOption1: 3,
    ipsRegion1: 4,
    ipsLocationNum1: 5,
    inventoryPlacedIn1: 6,
    ipsShipmentCost1: 7,
    program2: 8,
    ipsOption2: 10,
    ipsRegion2: 11,
    ipsLocationNum2: 12,
    inventoryPlacedIn2: 13,
    ipsShipmentCost2: 14,
    storageSeason: 15
};

export const PROGRAM_HEADER_TO_INDEX_MAP = {
    amazonStore: 0,
    program1: 1,
    inventoryPlacedIn1: 3,
    program2: 4,
    inventoryPlacedIn2: 6,
    storageSeason: 7
}

export const ITEM_HEADER_TO_INDEX_MAP = {
    sku: 0,
    fnsku: 1,
    asin: 2,
    productName: 3,
    feeCategory: 4,
    longestSide: 5,
    medianSide: 6,
    shortestSide: 7,
    unitOfDimension: 8,
    itemPackageWeight: 9,
    unitOfWeight: 10,
    price: 11,
    currency: 12,
    costOfGoodsSold: 13,
    shippingToAmazon: 14,
    averageInventoryUnitsStored: 15,
    estimatedMonthlyUnitsSold: 16,
    estimatedSales: 17,
    mfnFulfillmentCostPerUnit: 18, // MFN input
    mfnMonthlyStorageCostPerUnit: 19, // MFN input
    mfnDeliveryCharge: 20,
    miscellaneousCost: 21,
    isInventoryPlacementChosen: 22,
    isOpaqueBaggingChosen: 23,
    isTapingChosen: 24,
    isLabellingChosen: 25,
    isPolyBaggingChosen: 26,
    isBubbleWrapChosen: 27
};

export const ITEM_HEADER_TO_INDEX_MAP_NA = {
    sku: 0,
    fnsku: 1,
    asin: 2,
    productName: 3,
    feeCategory: 4,
    unitsToInbound: 5,
    longestSide: 6,
    medianSide: 7,
    shortestSide: 8,
    unitOfDimension: 9,
    itemPackageWeight: 10,
    unitOfWeight: 11,
    price: 12,
    currency: 13,
    costOfGoodsSold: 14,
    shippingToAmazon: 15,
    averageInventoryUnitsStored: 16,
    estimatedMonthlyUnitsSold: 17,
    estimatedSales: 18,
    mfnFulfillmentCostPerUnit: 19, // MFN input
    mfnMonthlyStorageCostPerUnit: 20, // MFN input
    mfnDeliveryCharge: 21,
    miscellaneousCost: 22,
    isInventoryPlacementChosen: 23,
    isOpaqueBaggingChosen: 24,
    isTapingChosen: 25,
    isLabellingChosen: 26,
    isPolyBaggingChosen: 27,
    isBubbleWrapChosen: 28
};


export const PROGRAM_DATA_INDEX = 1;
export const PROGRAM_DATA_LENGTH = 8;
export const PROGRAM_DATA_IPS = 16;
export const ITEM_HEADER_INDEX = 2;
export const ITEM_DATA_LENGTH_OLD = 28; // Due to IPS, now the item data may vary
export const ITEM_DATA_LENGTH_NEW = 30;
export const MAX_ITEM_COLUMN_VAL = isLoginMode() ? 1003 : 23;
export const BATCH_CALL_SIZE = 60;